import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Formik } from "formik";
import { useNavigate } from "react-router-dom";
import { DefaultLayout } from "../../layouts/Default";
import { TopNavigation } from "../../themes/Default/components/TopNavigation";
import { Breadcrumps } from "../../themes/Default/components/Breadcrumps";
import { Link } from "../../themes/Default/components/Breadcrumps/components/Link";
import { Main } from "../../themes/Default/components/Main";
import { Tabs } from "../../themes/Default/components/Tabs";
import { ButtonBack, Button } from "../../themes/Default/components/TopNavigation/components/Button";
import { Form } from "../../themes/Default/components/Form";
import { Row } from "../../themes/Default/components/Form/components/Row";
import { Field } from "../../themes/Default/components/Form/components/Row/components/Field";
import { Input } from "../../themes/Default/components/Form/components/Input";
import { Select } from "../../themes/Default/components/Form/components/Select";
import { Textarea } from "../../themes/Default/components/Form/components/Textarea";
import { Wizard } from "../../themes/Default/components/Wizard";
import { Step } from "../../themes/Default/components/Wizard/Step";
import { prepareSelect } from "../../services/core/Select";
import { locationsManagement } from "../../hooks/api/LocationsManagement";
import { languagesManagement } from "../../hooks/api/LanguagesManagement";
import { languageProgramsManagement } from "../../hooks/api/LanguageProgramsManagement";
import { groupsManagement } from "../../hooks/api/GroupsManagement";
import { groupTypesManagement } from "../../hooks/api/GroupTypesManagement/GroupTypesManagement";
import { Title } from "../../themes/Default/components/Title";
import Divider from "../../themes/Default/components/Divider/Divider";
import TimePicker from "../../themes/Default/components/Form/components/TimePicker/TimePicker";
import { settingsCallManagement } from "../../hooks/api/SettingsCallManagement";

const AddGroup = () => {
    const navigate = useNavigate();
    const { t } = useTranslation("common");
    const formRef = useRef(null);
    const [locations, setLocations] = useState([]);
    const [languages, setLanguages] = useState([]);
    const [groupTypes, setGroupTypes] = useState([]);
    const [languageProgramDisabled, setLanguageProgramDisabled] = useState(true);
    const [formErrors, setFormErrors] = useState([]);
    const [languageProgram, setLanguageProgram] = useState([]);
    const [isBlockClass, setIsBlockClass] = useState([]);
    const [classDuration, setClassDuration] = useState([]);

    const tabs = [{ title: t('details'), link: "/settings/reports", isActive: true }];

    const { useLocationListMutation } = locationsManagement;
    const { useLanguageListMutation } = languagesManagement;
    const { useProgramListMutation } = languageProgramsManagement;
    const { useAddGroupMutation } = groupsManagement;
    const { useGroupTypesListMutation } = groupTypesManagement;

    const [locationList, { isLoading }] = useLocationListMutation();
    const [languageList] = useLanguageListMutation();
    const [languageProgramList] = useProgramListMutation();
    const [groupTypesList] = useGroupTypesListMutation();
    const [addGroup] = useAddGroupMutation();

    const [appointment, setAppointment] = useState([]);
    const { useAppointmentListMutation } = settingsCallManagement;
    const [appointmentList] = useAppointmentListMutation();

    const [selectedWeekdays, setSelectedWeekdays] = useState([]);
    const [selectedWeekdays2, setSelectedWeekdays2] = useState([]);
    const weekDays = ["P", "U", "S", "Č", "P", "S", "N"];
    const toggleWeekday = (dayIndex) => {
        setSelectedWeekdays((prev) => (prev.includes(dayIndex) ? prev.filter((d) => d !== dayIndex) : [...prev, dayIndex]));
    };
    const toggleWeekday2 = (dayIndex) => {
        setSelectedWeekdays2((prev) => (prev.includes(dayIndex) ? prev.filter((d) => d !== dayIndex) : [...prev, dayIndex]));
    };

    const onSave = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    const onSaved = (values) => {
        const body = {
            ...values,
            weekDays: selectedWeekdays,
            weekDays2: selectedWeekdays2,
        };
        addGroup(body).then((result) => {
            if (result?.error) {
                console.log(result);
                setFormErrors(result?.error?.data?.error?.violations);
                toast.error(result.error.data.error.responseMessage);
            } else {
                navigate("/groups/" + result?.data?.id + "/students/add");
            }
        });
    };

    const yesNoOptions = () => {
        const options = [
            { id: 1, name: t('groups.isBlockClassYes') },
            { id: 0, name: t('groups.isBlockClassNo') }
        ];

        return prepareSelect(options);
    };

    const classDurations = () => {
        const options = [
            { id: 60, name: "60" },
            { id: 90, name: "90" },
        ];
    
        return prepareSelect(options);
    };

    useEffect(() => {
        locationList().then((result) => {
            setLocations(prepareSelect(result?.data?.records));
        });

        languageList().then((result) => {
            setLanguages(prepareSelect(result?.data?.records));
        });

        groupTypesList().then((result) => {
            setGroupTypes(prepareSelect(result?.data?.records));
        });

        appointmentList().then((result) => {
            let options = [];
            result?.data?.records.map((appointment) => {
                options.push({
                    id: appointment.id,
                    name: appointment.name,
                });
            });
            setAppointment(prepareSelect(options));
        });

        setIsBlockClass(yesNoOptions);
        setClassDuration(classDurations);     
    }, []);


    return (
        <DefaultLayout>
            
            <TopNavigation>
                <ButtonBack to="/groups" />
                <Button title={t('save')} icon="fa-regular fa-floppy-disk" onClick={onSave}></Button>
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
                <Title>{t('groups.title')}</Title>
                <Breadcrumps>
                    <Link title={t('groups.title')} icon="fa-light fa-users"/>
                    <Link title={t('details')} isActive={true}/>
                </Breadcrumps>
                <br/>
                <br/>
                <br/>
                <Wizard>
                    <Step title={t('groups.basicInfo')} isActive={true} />
                    <Step title={t('groups.chooseStudents')} isChecked={true} />
                    <Step title={t('groups.chooseProfessor')} isChecked={true} />
                    <Step title={t('groups.selectDates')} isChecked={true}  />
                </Wizard>
                <br/>
                <br/>
                <br/>
                <Formik
                    innerRef={formRef}
                    initialValues={{ 
                        name: "", 
                        location: null, 
                        color: "", 
                        professor: null,
                        coordinator: null,
                        note: "", 
                        language: "", 
                        program: "", 
                        hasStarted: false, 
                        isBlockClass: false,
                        type: null,
                        classStartTime: "",
                        classStartTime2: ""
                    }}
                    onSubmit={onSaved}
                >
                    {({ values, handleChange, setFieldValue }) => (
                        <Form>
                            <Row>
                                <Field>
                                    <Select 
                                        name="language" 
                                        label={t('groups.language')} 
                                        onChange={(event) => {
                                            setFieldValue('language', event.target.value);
                                            setLanguageProgramDisabled(false);
                                            languageProgramList({language: event.target.value}).then((result) => {
                                                setLanguageProgram(prepareSelect(result?.data?.records));
                                            });
                                        }}
                                        required={true} 
                                        options={languages} 
                                        selectedValue={values.language} 
                                        error={formErrors?.language}
                                        searchInDropdown={false}
                                    />
                                </Field>
                                <Field>
                                    <Select 
                                        name="program" 
                                        label={t('groups.languageProgram')} 
                                        onChange={handleChange} 
                                        required={true}
                                        options={languageProgram} 
                                        selectedValue={values.program} 
                                        error={formErrors?.program}
                                        disabled={languageProgramDisabled}
                                        searchInDropdown={false}
                                    />
                                </Field>
                            </Row>
                            <Row>
                                <Field>
                                    <Select 
                                        name="location" 
                                        label={t('groups.location')} 
                                        onChange={handleChange} 
                                        required={true} 
                                        options={locations} 
                                        selectedValue={values.location}
                                        error={formErrors?.location}
                                        searchInDropdown={false}
                                    />
                                </Field>
                                <Field>
                                    <Select 
                                        name="type" 
                                        label={t('groups.type')} 
                                        onChange={handleChange} 
                                        required={true}
                                        options={groupTypes} 
                                        selectedValue={values.type} 
                                        error={formErrors?.type}
                                        searchInDropdown={false}
                                    />
                                </Field>   
                            </Row>
                            <Row>
                                <Field>
                                    <Input 
                                        name="classNumber" 
                                        label={t('groups.classNumber')} 
                                        value={values.classNumber} 
                                        onChange={handleChange} 
                                        required={true} 
                                        error={formErrors?.classNumber}
                                    />
                                </Field>
                                <Field>
                                    <Select 
                                        name="classDuration" 
                                        label={t('groups.classDuration')}
                                        onChange={handleChange} 
                                        required={true} 
                                        options={classDuration} 
                                        selectedValue={values.classDuration}
                                        error={formErrors?.classDuration}
                                        searchInDropdown={false}
                                    />
                                </Field>
                            </Row>
                            <Row>
                                <Field>
                                    <Select
                                        name="appointment"
                                        label={t("Termin kampa")}
                                        options={appointment}
                                        onChange={handleChange}
                                        selectedValue={values.appointment}
                                        error={formErrors?.appointment}
                                        searchInDropdown={false}
                                    />
                                </Field>
                                <Field></Field>
                            </Row>
                            <Divider title={t("Prvi termin")} />
                            <Row>
                                <Field>
                                    <TimePicker
                                        name="classStartTime"
                                        label={t("groups.classStartTime")}
                                        required={true}
                                        value={values.classStartTime}
                                        onChange={handleChange}
                                        error={formErrors?.classStartTime}
                                    />
                                </Field>
                                <Field></Field>
                            </Row>
                            <Row>
                                <Field>
                                    <div className="bulkCalendar__label">Kombinacija dana *</div>
                                    <div className="bulkCalendar__days">
                                        {weekDays.map((dayLabel, index) => (
                                            <div
                                                key={index}
                                                className={`bulkCalendar__day ${index >= 5 ? "weekend" : ""} ${selectedWeekdays.includes(index) ? "active" : ""}`}
                                                onClick={() => toggleWeekday(index)}
                                            >
                                                {dayLabel}
                                            </div>
                                        ))}
                                    </div>
                                    <div className="bulkCalendar__error">{formErrors?.weekDays}</div>
                                </Field>
                            </Row>
                            <Divider title={t("Drugi termin")} />
                            <Row>
                                <Field>
                                    <TimePicker
                                        name="classStartTime2"
                                        label={t("groups.classStartTime2")}
                                        value={values.classStartTime2}
                                        onChange={handleChange}
                                        error={formErrors?.classStartTime2}
                                    />
                                </Field>
                                <Field></Field>
                            </Row>
                            <Row>
                                <Field>
                                    <div className="bulkCalendar__label">Kombinacija dana 2</div>
                                    <div className="bulkCalendar__days">
                                        {weekDays.map((dayLabel, index) => (
                                            <div
                                                key={index}
                                                className={`bulkCalendar__day ${index >= 5 ? "weekend" : ""} ${selectedWeekdays2.includes(index) ? "active" : ""}`}
                                                onClick={() => toggleWeekday2(index)}
                                            >
                                                {dayLabel}
                                            </div>
                                        ))}
                                    </div>
                                    <div className="bulkCalendar__error">{formErrors?.weekDays}</div>
                                </Field>
                            </Row>
                            <Divider title={t("additionalInformation")} />
                            <Row>
                                <Field isFullWidth={true}>
                                    <Textarea 
                                        name="note" 
                                        label={t('groups.note')} 
                                        onChange={handleChange} 
                                        value={values.note} 
                                        rows={5} 
                                        error={formErrors?.note}
                                    />
                                </Field>
                            </Row>
                        </Form>
                    )}
                </Formik>
            </Main>
        </DefaultLayout>
    );
};

export default AddGroup;
